/* AP mega menu (desktop), 2026-10-09 preview. Markup: snippets/ap-mega-menu.liquid.
   <details> keeps it usable without JS (click/Enter toggles). This adds:
   - hover intent for mouse users (open after 90ms, close 220ms after leaving trigger + panel)
   - one panel open at a time, Escape / outside click / scrim click closes and returns focus
   - panel + scrim placed just under the header's current bottom edge */
(function () {
  var nav = document.querySelector('.apmm');
  if (!nav || nav.dataset.apmmReady) return;
  nav.dataset.apmmReady = '1';

  var items = Array.prototype.slice.call(nav.querySelectorAll('[data-apmm]'));
  var scrim = nav.querySelector('[data-apmm-scrim]');
  var header = document.querySelector('.section-header') || nav.closest('header');
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
  var openTimer = null;
  var closeTimer = null;

  function placeTop() {
    var anchor = document.querySelector('.header-wrapper') || header;
    var bottom = anchor ? anchor.getBoundingClientRect().bottom : 0;
    nav.style.setProperty('--apmm-top', Math.max(0, Math.round(bottom)) + 'px');
  }
  function closeAll(except) {
    items.forEach(function (d) { if (d !== except && d.open) d.open = false; });
    if (!except && scrim) scrim.hidden = true;
  }
  function open(d) {
    clearTimeout(closeTimer);
    placeTop();
    closeAll(d);
    if (!d.open) d.open = true;
    var full = !d.querySelector('.apmm__panel--list');
    if (scrim) scrim.hidden = !full;
  }

  items.forEach(function (d) {
    var summary = d.querySelector('summary');
    d.addEventListener('toggle', function () {
      if (d.open) { placeTop(); closeAll(d); if (scrim) scrim.hidden = !!d.querySelector('.apmm__panel--list'); }
      else if (!items.some(function (x) { return x.open; }) && scrim) scrim.hidden = true;
    });
    d.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !hoverable.matches) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { open(d); }, items.some(function (x) { return x.open; }) ? 0 : 90);
    });
    d.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse' || !hoverable.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { if (d.open) d.open = false; }, 220);
    });
    // Mouse users get hover; a click on the trigger should navigate-like toggle without flicker.
    summary.addEventListener('click', function (e) {
      if (hoverable.matches && d.open && e.detail > 0) { e.preventDefault(); }
    });
  });

  // Hover cards (Scent Membership): the pill stays a link; the card opens on hover intent and on focus (CSS).
  var cards = Array.prototype.slice.call(nav.querySelectorAll('[data-apmm-card]'));
  cards.forEach(function (c) {
    var t1 = null, t2 = null;
    c.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !hoverable.matches) return;
      clearTimeout(t2);
      c.classList.remove('is-dismissed');
      t1 = setTimeout(function () { closeAll(); c.classList.add('is-open'); }, 90);
    });
    c.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(t1);
      t2 = setTimeout(function () { c.classList.remove('is-open'); }, 200);
    });
  });
  function closeCards() { cards.forEach(function (c) { c.classList.remove('is-open'); if (c.contains(document.activeElement)) c.classList.add('is-dismissed'); }); }
  cards.forEach(function (c) { c.addEventListener('focusout', function () { c.classList.remove('is-dismissed'); }); });
  items.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) closeCards(); }); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCards();
    if (e.key !== 'Escape') return;
    var openOne = items.filter(function (d) { return d.open; })[0];
    if (openOne) { openOne.open = false; openOne.querySelector('summary').focus(); }
  });
  document.addEventListener('click', function (e) {
    if (!nav.contains(e.target) || e.target === scrim) closeAll();
  });
  nav.addEventListener('focusout', function (e) {
    if (e.relatedTarget && !nav.contains(e.relatedTarget)) closeAll();
  });
  window.addEventListener('scroll', function () { if (items.some(function (d) { return d.open; })) closeAll(); }, { passive: true });
  window.addEventListener('resize', placeTop);

  // Gliding spotlight: follows the pointer across the bar, rests on the open panel's item.
  var glide = nav.querySelector('[data-apmm-glide]');
  var bar = nav.querySelector('.apmm__bar');
  if (glide && bar && hoverable.matches) {
    var targets = Array.prototype.slice.call(bar.querySelectorAll('.apmm__trigger, .apmm__li > a.header__menu-item, .apmm__cardwrap > a.header__menu-item'));
    function moveTo(el) {
      if (!el) { glide.classList.remove('is-on'); return; }
      var b = bar.getBoundingClientRect(), r = el.getBoundingClientRect();
      glide.style.width = r.width + 'px';
      glide.style.height = r.height + 'px';
      glide.style.transform = 'translate(' + (r.left - b.left) + 'px,' + (r.top - b.top) + 'px)';
      glide.classList.add('is-on');
    }
    var hovered = null; // a panel closing late must not switch the spotlight off the item under the pointer
    function rest() {
      var open = items.filter(function (d) { return d.open; })[0];
      moveTo(open ? open.querySelector('summary') : hovered);
    }
    targets.forEach(function (el) { el.addEventListener('pointerenter', function () { hovered = el; moveTo(el); }); });
    bar.addEventListener('pointerleave', function () { hovered = null; setTimeout(rest, 60); });
    items.forEach(function (d) { d.addEventListener('toggle', function () { setTimeout(rest, 0); }); });
    window.addEventListener('resize', rest);
  }
})();
